import {jwtDecode} from "jwt-decode";


export const SET_USER = 'SET_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

export const setUser = (token) => {
  return (dispatch) => {
    try {
      const decodedToken = jwtDecode(token);
      const userData = {
        name: decodedToken.name || 'user',
        email: decodedToken.email,
      };
      localStorage.setItem('authToken', token);
      dispatch({
        type: SET_USER,
        payload: userData,
      });
    } catch (error) {
      console.error("Failed to decode token:", error);
      
    }
  };
};

export const logoutUser = () => (dispatch) => {
  localStorage.removeItem('authToken'); 
  dispatch({ type: 'USER_LOGOUT' }); 
};

